var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCargoCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.055 7.83l-4.83 1.294a2 2 0 00-1.413 2.45l.179.668.08.297a2 2 0 002.449 1.414l4.278-1.146.552-.148a2 2 0 001.414-2.45l-.26-.965a2 2 0 00-2.449-1.414z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.83 3.518l-3.444.922a2 2 0 00-1.414 2.45l.179.669.08.297A2 2 0 0010.68 9.27l3.288-.88.156-.043a2 2 0 001.414-2.45l-.259-.965a2 2 0 00-2.45-1.414z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.146 15.018l-7.443 1.994c-.446.12-.669.18-.873.15 0 0-.351-.102-.492-.218-.158-.13-.261-.333-.467-.735C8.274 14.8 3.5 4 3.5 4L1 5.118m9.488 16.093a2 2 0 11-1.035-3.864 2 2 0 011.035 3.864z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgCargoCart;